<template>
  <div class="box">
    <slot name="codeSlot"></slot>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
}
</script>

<style lang="less" scoped>
.box{
  width: 140px;
  height: 140px;
}
</style>